export default __webpack_public_path__ + "static/media/Blank-logo.99048ba7.jpg";